import "./App.css";
import { Header } from "./components/Header";
import { NavBar } from "./components/NavBar";
import { TabsNavigation } from "./components/TabsNavigation";
import { AboutMe } from "./components/AboutMe";
import { WorkExperience } from "./components/WorkExperience";
import { Projects } from "./components/Projects";
import { Languages } from "./components/Languages";

function App() {
  return (
    <>
      <NavBar />
      <div className="Container">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            rowGap: "24px",
          }}
        >
          <Header />
          <TabsNavigation />
        </div>
        <AboutMe />
        <WorkExperience />
        <Projects />
        <Languages />
      </div>
    </>
  );
}

export default App;
